/* eslint-disable class-methods-use-this */
class EventsHandler {
  track(category, action, label, value, extra) {
    if (typeof ga !== 'undefined') {
      ga(() => {
        this.google(category, action, label, value, extra);
      });
    }

    this.facebook(category, action, label, value, extra);

    // log to console for debugging
    // if(typeof console != "undefined" && typeof console.log != "undefined" && process.env.DEBUG) {
    //     console.log(category, " - ", action, " - ", label, " - ", value, " - ", extra)
    // }
  }

  google(category, action, label, value, extra) {
    if (typeof ga !== 'undefined') {
      if (extra) {
        ga('set', 'currencyCode', extra.currencyCode); // Set tracker currency
      }

      if (category === 'Categories' && action === 'Category Browse') {
        if (extra && extra.products) {
          extra.products.forEach((product) => {
            ga('ec:addImpression', {
              // Provide product details in an impressionFieldObject.
              id: product.id, // Product ID (string).
              name: product.name, // Product name (string).
              category: product.category, // Product category (string).
              brand: 'Article', // Product brand (string).
              list: 'Category Browse', // Product list (string).
              position: product.position, // Product position (number).
            });
          });
        }
      } else if (category === 'Categories' && action === 'Category Scroll') {
        if (extra && extra.products) {
          extra.products.forEach((product) => {
            ga('ec:addImpression', {
              // Provide product details in an impressionFieldObject.
              id: product.id, // Product ID (string).
              name: product.name, // Product name (string).
              category: product.category, // Product category (string).
              brand: 'Article', // Product brand (string).
              list: 'Category Browse', // Product list (string).
              position: product.position, // Product position (number).
            });
          });
        }
      } else if (category === 'Search' && action === 'Search Query') {
        if (extra && extra.products) {
          extra.products.forEach((product) => {
            ga('ec:addImpression', {
              // Provide product details in an impressionFieldObject.
              id: product.id, // Product ID (string).
              name: product.name, // Product name (string).
              category: product.category, // Product category (string).
              brand: 'Article', // Product brand (string).
              list: 'Search Results', // Product list (string).
              position: product.position, // Product position (number).
            });
          });
        }
      } else if (category === 'Search' && action === 'Search Scroll') {
        if (extra && extra.products) {
          extra.products.forEach((product) => {
            ga('ec:addImpression', {
              // Provide product details in an impressionFieldObject.
              id: product.id, // Product ID (string).
              name: product.name, // Product name (string).
              category: product.category, // Product category (string).
              brand: 'Article', // Product brand (string).
              list: 'Search Results', // Product list (string).
              position: product.position, // Product position (number).
            });
          });
        }
      } else if (category === 'Promotions' && action === 'Promotion Browse') {
        if (extra && extra.products) {
          extra.products.forEach((product) => {
            ga('ec:addImpression', {
              // Provide product details in an impressionFieldObject.
              id: product.id, // Product ID (string).
              name: product.name, // Product name (string).
              category: product.category, // Product category (string).
              brand: 'Article', // Product brand (string).
              list: 'Promotion Browse', // Product list (string).
              position: product.position, // Product position (number).
            });
          });
        }
      } else if (category === 'Promotions' && action === 'Promotion Scroll') {
        if (extra && extra.products) {
          extra.products.forEach((product) => {
            ga('ec:addImpression', {
              // Provide product details in an impressionFieldObject.
              id: product.id, // Product ID (string).
              name: product.name, // Product name (string).
              category: product.category, // Product category (string).
              brand: 'Article', // Product brand (string).
              list: 'Promotion Browse', // Product list (string).
              position: product.position, // Product position (number).
            });
          });
        }
      } else if (category === 'Tags' && action === 'Tag Browse') {
        if (extra && extra.products) {
          extra.products.forEach((product) => {
            ga('ec:addImpression', {
              // Provide product details in an impressionFieldObject.
              id: product.id, // Product ID (string).
              name: product.name, // Product name (string).
              category: product.category, // Product category (string).
              brand: 'Article', // Product brand (string).
              list: 'Promotion Browse', // Product list (string).
              position: product.position, // Product position (number).
            });
          });
        }
      } else if (category === 'Tags' && action === 'Tag Scroll') {
        if (extra && extra.products) {
          extra.products.forEach((product) => {
            ga('ec:addImpression', {
              // Provide product details in an impressionFieldObject.
              id: product.id, // Product ID (string).
              name: product.name, // Product name (string).
              category: product.category, // Product category (string).
              brand: 'Article', // Product brand (string).
              list: 'Promotion Browse', // Product list (string).
              position: product.position, // Product position (number).
            });
          });
        }
      } else if (category === 'Product' && action === 'Product Viewed') {
        if (extra) {
          // The product being viewed.
          ga('ec:addProduct', {
            id: extra.id,
            name: extra.name,
            category: extra.category,
            brand: 'Article',
            price: extra.price,
          });

          ga('ec:setAction', 'detail'); // Detail action.
        }
      } else if (category === 'Products' && action === 'Add To Cart') {
        if (extra) {
          ga('ec:addProduct', {
            id: extra.id,
            name: extra.name,
            category: extra.category,
            brand: 'Article',
            price: extra.price,
            quantity: 1,
          });

          ga('ec:setAction', 'add');
          ga('send', 'event', 'Checkout', 'Add to Cart');
        }
      } else if (category === 'Cart' && action === 'Update') {
        // GA Advance Ecommerce does not support Cart Update. It has indiviual events like add/remove products.
      } else if (category === 'Checkout' && action === 'Purchase') {
        if (extra && extra.products) {
          extra.products.forEach((product) => {
            ga('ec:addProduct', {
              // Provide product details in an impressionFieldObject.
              id: product.id, // Product ID (string).
              name: product.name, // Product name (string).
              category: product.category, // Product category (string).
              brand: 'Article', // Product brand (string).
              price: product.price,
              quantity: product.quantity,
            });
          });

          // Transaction level information is provided via an actionFieldObject.
          ga('ec:setAction', 'purchase', {
            id: extra.orderId,
            affiliation: 'Article',
            revenue: extra.total,
          });
        }
      } else {
        ga('send', 'event', category, action, label, value);
      }
    }
  }

  facebook(category, action, label, value, extra) {
    if (typeof _fbevents !== 'undefined') {
      if (category === 'Categories' && action === 'Category Browse') {
        // View category
        if (extra && extra.products) {
          _fbevents({
            type: 'trackCustom',
            event: 'ViewCategory',
            value: {
              content_name: extra.category,
              content_category: extra.categoryPath,
              content_ids: EventsHandler.getSkuNumbers(extra.products), // top 5-10 results
              content_type: 'product',
            },
          });
        }
      } else if (category === 'Promotions' && action === 'Promotion Browse') {
        // View category
        if (extra && extra.products) {
          _fbevents({
            type: 'trackCustom',
            event: 'ViewCategory',
            value: {
              content_name: extra.promotion,
              content_category: extra.promotion,
              content_ids: EventsHandler.getSkuNumbers(extra.products), // top 5-10 results
              content_type: 'product',
            },
          });
        }
      } else if (category === 'Tags' && action === 'Tag Browse') {
        // View category
        if (extra && extra.products) {
          _fbevents({
            type: 'trackCustom',
            event: 'ViewCategory',
            value: {
              content_name: extra.tag,
              content_category: extra.tag,
              content_ids: EventsHandler.getSkuNumbers(extra.products), // top 5-10 results
              content_type: 'product',
            },
          });
        }
      } else if (category === 'Search' && action === 'Search Query') {
        // Search
        if (extra && extra.products) {
          _fbevents({
            type: 'track',
            event: 'Search',
            value: {
              search_string: extra.q,
              content_ids: EventsHandler.getSkuNumbers(extra.products), // top 5-10 search results
              content_type: 'product',
            },
          });
        }
      } else if (category === 'Product' && action === 'Product Viewed') {
        // View content
        if (extra) {
          _fbevents({
            type: 'track',
            event: 'ViewContent',
            value: {
              content_ids: [extra.id],
              content_type: 'product',
              value: extra.price,
              currency: extra.currencyCode,
            },
            eventID: {
              eventID: extra.hashedId,
            },
          });
        }
      } else if (category === 'Products' && action === 'Add To Cart') {
        // Add to cart
        if (extra) {
          _fbevents({
            type: 'track',
            event: 'AddToCart',
            value: {
              content_ids: [extra.id],
              content_type: 'product',
              value: extra.price,
              currency: extra.currencyCode,
            },
            eventID: {
              eventID: extra.hashedId,
            }
          });
        }
      } else if (category === 'Checkout' && action === 'Initiate Checkout') {
        _fbevents({
          type: 'track',
          event: 'InitiateCheckout',
          eventID: {
            eventID: extra.hashedId,
          }
        });
      } else if (category === 'Checkout' && action === 'Purchase') {
        // Make purchase
        if (extra && extra.products) {
          _fbevents({
            type: 'track',
            event: 'Purchase',
            value: {
              content_ids: EventsHandler.getSkuNumbers(extra.products),
              content_type: 'product',
              value: extra.total,
              currency: extra.currencyCode,
            },
            eventID: {
              eventID: extra.hashedId,
            },
          });
        }
      }
    }
  }

  static getSkuNumbers(products) {
    return products.map((p) => p.id);
  }

  getCategoryTree(category) {
    let tree = [];
    if (category) {
      tree = category.split('/');
    }
    return tree;
  }
}

export default new EventsHandler();
